import { useEffect, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { buildOauthAuthorizeUrl } from '../oidc';

/**
 * OAuth sign-in INITIATION (`/signin/oauth`).
 *
 * Restores the legacy portal's redirect-to-provider step (legacy
 * `src/app/pages/Auth/Oauth/index.js`) that the portalshadcn migration dropped —
 * the migration pointed BOTH `/signin/oauth` and `/signin/oauth/redirect` at the
 * callback page, so `/signin/oauth` never sent the browser to Keycloak and
 * immediately failed with "no code in the URL".
 *
 * Sends the browser to the Keycloak authorization endpoint; the provider returns
 * to `/signin/oauth/redirect?code=…`, which `OAuthCallbackPage` exchanges. The
 * redirect runs in an effect (not the render body, unlike legacy) so it fires
 * once after mount and is mockable in tests.
 */
export function OAuthStartPage(): JSX.Element {
  const { t } = useTranslation('auth');

  useEffect(() => {
    window.location.assign(buildOauthAuthorizeUrl(window.location.origin));
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-background px-4 py-12">
      <div className="w-full max-w-md">
        <Card data-testid="oauth-start-page">
          <CardHeader>
            <CardTitle>{t('oauth.redirecting')}</CardTitle>
            <CardDescription className="flex items-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              <span>OrderMesh</span>
            </CardDescription>
          </CardHeader>
        </Card>
      </div>
    </main>
  );
}
